/** Negative-number display format for a pivot measure's values. */
export enum PivotNegativeNumberFormatEnum {
  Minus = '-1',
  Parentheses = '(1)',
}
